import {useMediaQuery} from "@material-ui/core";

export const useIsMobile = () => useMediaQuery(theme => theme.breakpoints.between('xs', 'xs'));
export const useIsTablet = () => useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
export const useIsSmallTablet = () => useMediaQuery(theme => theme.breakpoints.between('sm', 'sm'));
export const useIsLargeTablet = () => useMediaQuery(theme => theme.breakpoints.between('md', 'md'));
export const useIsDesktop = () => useMediaQuery(theme => theme.breakpoints.up('lg'));


export const useIsMobileOrTablet = () => useMediaQuery(theme => theme.breakpoints.between('xs', 'md'));
export const useIsTabletOrDesktop = () => useMediaQuery(theme => theme.breakpoints.up('sm',));
